/* AP 6.0 — page « Nos cadres » (zone E) : comparateur + scène du canapé. Sans dépendance, utilise ap-frame.js (AP.setCadre, AP.framePrice, AP.money). */
(function () {
  'use strict';
  if (window.__apCadres) return; window.__apCadres = 1;
  var AP = window.AP || {};
  /* même format que le filtre Liquid | money (shop.money_format), pour que les prix recalculés ressemblent aux prix serveur */
  function fmtMoney(c, f) {
    var m = f && f.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return AP.money ? AP.money(c) : (c / 100).toFixed(2);
    function n(d, th, dec) { var p = (c / 100).toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dec + p[1] : ''); }
    var v = { amount: n(2, ',', '.'), amount_no_decimals: n(0, ',', '.'), amount_with_comma_separator: n(2, '.', ','), amount_no_decimals_with_comma_separator: n(0, '.', ','), amount_with_apostrophe_separator: n(2, "'", '.'), amount_with_space_separator: n(2, ' ', ','), amount_no_decimals_with_space_separator: n(0, ' ', ',') }[m[1]] || n(2, ',', '.');
    return f.replace(m[0], v);
  }
  function fp(size, id) { return id && AP.framePrice ? AP.framePrice(size, id) : 0; }
  function setCadre(id, root) { if (AP.setCadre) AP.setCadre(id, root); }
  function press(list, attr, val) { list.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute(attr) === val)); }); }

  /* ---- comparateur ---- */
  document.querySelectorAll('[data-ap-cmp]').forEach(function (root) {
    var D, money = function (c) { return fmtMoney(c, root.dataset.money); }; try { D = JSON.parse(root.querySelector('[data-ap-cmp-i18n]').textContent); } catch (e) { return; }
    var S = { f: 'noir', s: 'l', p: '0' };
    var big = root.querySelector('[data-ap-big]');
    var fb = root.querySelectorAll('[data-ap-f]'), sb = root.querySelectorAll('[data-ap-s]'), pb = root.querySelectorAll('[data-ap-p]');
    function q(s) { return root.querySelector(s); }
    function render() {
      var b = root.querySelector('[data-ap-p="' + S.p + '"]'); if (!b) return;
      var poster = +b.dataset[S.s] || 0, frame = fp(S.s, S.f);
      big.dataset.s = S.s;
      big.querySelectorAll('[data-ap-pv]').forEach(function (v) { v.hidden = v.dataset.apPv !== S.p; });
      setCadre(S.f, big);
      q('[data-ap-cap]').textContent = b.dataset.title + ' · ' + S.s.toUpperCase() + ' ' + D.dims[S.s] + ' · ' + D.t[S.f];
      q('[data-ap-sum-t]').textContent = D.t[S.f];
      q('[data-ap-sum-d]').textContent = D.d[S.f];
      q('[data-ap-sum-p]').textContent = money(poster + frame);
      q('[data-ap-sum-c]').textContent = S.f ? D.calc.replace('%p', money(poster)).replace('%f', money(frame)) : D.calc_none.replace('%s', S.s.toUpperCase());
      q('[data-ap-sum-u]').href = b.dataset.url;
      press(fb, 'data-ap-f', S.f); press(sb, 'data-ap-s', S.s); press(pb, 'data-ap-p', S.p);
    }
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-ap-f],[data-ap-s],[data-ap-p]'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-ap-f')) S.f = t.getAttribute('data-ap-f');
      else if (t.hasAttribute('data-ap-s')) S.s = t.getAttribute('data-ap-s');
      else S.p = t.getAttribute('data-ap-p');
      render();
    });
  });

  /* ---- scène du canapé : 1 XL + 2 M, cadre au choix, le 3ᵉ offert = un M encadré ---- */
  document.querySelectorAll('[data-ap-scene]').forEach(function (root) {
    var chips = root.querySelectorAll('[data-ap-sf]'), out = root.querySelector('[data-ap-sitp]'), stage = root.querySelector('.ap-cg-stage');
    var money = function (c) { return fmtMoney(c, root.dataset.money); }, pm = +root.dataset.pm || 0, pxl = +root.dataset.pxl || 0, tpl = root.dataset.tpl || '';
    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-ap-sf]'); if (!t) return;
      var id = t.getAttribute('data-ap-sf');
      setCadre(id, stage); press(chips, 'data-ap-sf', id);
      var m = pm + fp('m', id), full = pxl + fp('xl', id) + 2 * m;
      if (tpl && AP.framePrice) out.innerHTML = tpl.replace('%f', t.dataset.name).replace('%p', money(full - m)).replace('%t', money(full));
    });
  });
})();
